<template>
  <div class="detail">
    <div class="channel-img">
      <van-image :src="detailObj.qrCode" />
      <p>长按识别二维码，或保存图片</p>
    </div>
    <div class="detail-person normal-card">
      <div class="flex-between">
        <h3>使用员工</h3>
        <span
          >共
          <b v-if="detailObj.users">{{ detailObj.users.length }}</b>
          <b v-else>0</b>
          人</span
        >
      </div>
      <ul>
        <li
          v-for="item in detailObj.users"
          :key="item.userid"
          class="flex-center"
        >
          <van-image round :src="item.avatar" />
          <span>{{ item.userName }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { infoList } from "@/server/api.js";
export default {
  data() {
    return {
      list: [],
      detailId: "",
      detailname: "",
      pageNum: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      total: 0, // 总条数
      detailObj: {},
    };
  },
  create() {
    this.detailname = this.$route.query.title;
    document.title = this.detailname;
  },
  mounted() {
    this.detailId = this.$route.query.id;
    this.getDetailList();
  },
  methods: {
    async getDetailList() {
      const res = await infoList({ id: this.detailId });
      if (res.code !== "200") return Toast.fail(res.msg);
      // 加载状态结束
      this.detailObj = res.data; //追加数据
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  width: 100%;
  height: 100vh;
  background: #f5f6fa;
  padding: 19px 30px;
  .channel-img {
    background: #fff;
    text-align: center;
    padding: 40px 105px;
    border-radius: 14px;
    margin-bottom: 20px;
    /deep/.van-image {
      width: 480px;
      height: 480px;
    }
    p {
      padding-top: 24px;
      color: #666666;
      font-size: 28px;
    }
  }
  .detail-person {
    padding: 26px 28px;
    h3 {
      font-size: 32px;
    }
    span {
      font-size: 24px;
      color: #666666;
      b {
        color: #333333;
        font-weight: normal;
      }
    }
    ul {
      li {
        border-bottom: 1px solid #f4f4f4;
        padding: 23px 0;
        .van-image {
          width: 60px;
          height: 60px;
        }
        &:last-child {
          border: none;
        }
        span {
          margin-left: 20px;
          color: #333;
          font-size: 28px;
        }
      }
    }
  }
}
</style>
